<template lang="pug">
  main
    NavBarCORP
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.section-title
          .column.is-half.is-offset-one-quarter.has-text-centered.has-text-dark
            h1.title Recursos Humanos&nbsp
              a.button.is-black.is-rounded(@click="backPage")
                i.fas.fa-times
        .columns.has-text-centered.is-centered.is-multiline.has-text-dark
          .column.is-3
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-file-signature.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Responsivas
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Responsivas") Entrar
</template>

<script>
import Loader from '@/components/shared/Loader.vue'
import NavBarCORP from '@/components/layout/NavBarCorpo.vue'
import { mapState } from 'vuex'
import InventarioServices from '@/services/inventario/inventario'
import ticketServices from "@/services/soporte/tickets"

export default {
  name: 'ApartadoRH',
  components: { Loader, NavBarCORP },
  data () {
    return {
      isLoading: false,
      verResponsivas: false,
      verRequisiciones: false,
      verRegistro: false,
      verReportes: false,
      verSoporte: false,
      verInventarios: false,
      verCombustibles: false,
      verSolicitudes: false,
      verGIA: false,
      isAlmacenistaCede: false,
    }
  },
  methods: {
    obtenerUser() {
      if (Object.keys(this.userLogin).length === 0) {
        this.$router.push('/')
      } else {
        switch (this.userLogin.cargo) {
          case '000':
            console.log('000 - admin')
            this.verReportes = true
            this.verInventarios = true
            this.verRegistro = true
            break
          case '001':
            console.log('001 - gerente')
            this.verResponsivas = true
            this.verReportes = true
            this.verSoporte = true
            this.verInventarios = true
            this.verCombustibles = true
            this.verSolicitudes = true
            break
          case '003':
            console.log('003 - Gerente GIA')
            this.verReportes = true
            this.verSoporte = true
            this.verResponsivas = true
            this.verInventarios = true
            break
          case '2100':
            console.log('2100 - Contralora')
            this.verResponsivas = true
            this.verRequisiciones = true
            this.verInventarios = true
            break
          case '330':
            console.log('330 - sistemasUser')
            this.verGIA = true
            this.verInventarios = true
            this.verSoporte = true
            break
          case '320':
            console.log('320 - Capital HUmano')
            this.verResponsivas = true
            break
          case '323':
            console.log('323 - Auditor')
            this.verResponsivas = true
            this.verInventarios = true
            this.isAlmacenistaCede = true
            this.verCombustibles = true
            break
          case '324':
            console.log('324 - Auditor')
            this.verInventarios = true
            this.isAlmacenistaCede = true
            break
          case '331':
            console.log('331 - Almacenista GIA')
            this.verGIA = true
            this.verReportes = true
            this.verResponsivas = true
            this.verInventarios = true
            break
          case '332':
            console.log('332 - Sistemas Almacenista')
            this.verGIA = true
            this.verReportes = true
            this.verResponsivas = true
            this.verInventarios = true
            break
          case '120':
            console.log('120 - Asistente CORP')
            this.verInventarios = true
            this.verResponsivas = true
            this.verCombustibles = true
            this.verRequisiciones = true
            this.verSolicitudes = true
            break
          case '160':
            console.log('160 - AdminUser')
            this.verInventarios = true
            this.verResponsivas = true
            this.verCombustibles = true
            this.verRequisiciones = true
            this.verSolicitudes = true
            break
          case '240':
            console.log('240 - jefe operaciones')
            break
          case '310':
            console.log('310 - instrumentacion')
            break
          case '341':
            console.log('341 - facturacion')
            break
          case '342':
            console.log('342 - bascula')
            break
          case '343':
            console.log('343 - bascula y facturacion')
            break
          case '350':
            console.log('350 - mantenimiento')
            break
          case '250':
            console.log('250 - jefe mantto.')
            break
          case '370':
            console.log('370 - seguridad')
            break
          case '270':
            console.log('370 - seguridad')
            break
          case '990': 
          console.log('990 - default')
            this.verInventarios = true
            break
          case '429': 
          console.log('990 - default')
            this.verRegistro = true
            break
        
          default:
            console.log('NINGUNO')
            verResponsivas = false
            verRequisiciones = false
            verRegistro = false
            verReportes = false
            verSoporte = false
            verInventarios = false
            verCombustibles = false
            verSolicitudes = false
            verGIA = false
            isAlmacenistaCede = false
            break
        }
      }
      
    },
    backPage() {
      this.$router.back()
    },
  },
  created () {
    this.$store.commit('irEstaciones','CORP')
    this.obtenerUser()
  },
  computed: {
    ...mapState(['logueado', 'userLogin'])
  },
}
</script>

<style lang="css" scoped>

  .image {
    display: inline-block;
  }
  .card:hover {
    transform: translateY(-5px) scale(1.005) translateZ(0);
    box-shadow: 0 24px 36px rgba(0,0,0,0.11), 0 14px 16px rgba(0,0,0,0.11);
  }
  .section-title {
    margin-top: 1rem;
    margin-bottom: 2rem;
  }

  .card {
    color: #54545c;
  }
</style>




// WEBPACK FOOTER //
// src/components/apartados/ApartadoRH.vue